'use strict';

var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var react = require('react');
var jsxRuntime = require('react/jsx-runtime');

var c=({children:l,className:i})=>{let s=i||"",m=react.Children.map(l,(t,n)=>jsxRuntime.jsx("li",{className:"container-list-item","data-before":n+1,children:jsxRuntime.jsx("div",{className:"content",children:t},t.props["data-uniqueKey"])},n));return jsxRuntime.jsx("ol",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-timeline ${s}`),children:m})},p=c;

exports.a = p;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-KLB7UNA7.js.map